<div class="admin-trades">
  <header class="admin-trades__head">
    <h2 class="mb-0">Trades</h2>
    @if (hasValidEditPermission()) {
      <button type="button" class="btn btn-outline btn-sm" (click)="addTrade()">
        <i class="bi bi-plus-lg me-1"></i>
        Add trade
      </button>
    }
  </header>

  <div class="admin-trades__grid-wrap">
    <app-primary-trades-grid
      [gridName]="'AdminPrimaryTrades'"
      [suppliedQueryData]="suppliedGridQuery"
      [ColumnIdToColumnActions]="ColumnIdToColumnActions"
      (actionEvent)="action($event)"
      [(reloadGridData)]="reloadGrid"
    ></app-primary-trades-grid>
  </div>

  <section class="admin-trades__section">
    <header
      class="admin-trades__collapse-head"
      (click)="collapseTradesRequirements = !collapseTradesRequirements"
    >
      <h3 class="mb-0">Trade requirements</h3>
      <i
        class="bi admin-trades__chevron"
        [ngClass]="{
          'bi-chevron-up': collapseTradesRequirements,
          'bi-chevron-down': !collapseTradesRequirements
        }"
      ></i>
    </header>
    <div [(ngbCollapse)]="collapseTradesRequirements">
      <app-admin-admin-trade-requirements></app-admin-admin-trade-requirements>
    </div>
  </section>

  <section class="admin-trades__section">
    <header
      class="admin-trades__collapse-head"
      (click)="collapseTradeCategories = !collapseTradeCategories"
    >
      <h3 class="mb-0">Trade categories</h3>
      <i
        class="bi admin-trades__chevron"
        [ngClass]="{
          'bi-chevron-up': collapseTradeCategories,
          'bi-chevron-down': !collapseTradeCategories
        }"
      ></i>
    </header>
    <div [(ngbCollapse)]="collapseTradeCategories">
      <app-admin-admin-trade-categories></app-admin-admin-trade-categories>
    </div>
  </section>

  <section class="admin-trades__section">
    <header
      class="admin-trades__collapse-head"
      (click)="
        collapseTradeSpecialtyCategories = !collapseTradeSpecialtyCategories
      "
    >
      <h3 class="mb-0">Trade specialty categories</h3>
      <i
        class="bi admin-trades__chevron"
        [ngClass]="{
          'bi-chevron-up': collapseTradeSpecialtyCategories,
          'bi-chevron-down': !collapseTradeSpecialtyCategories
        }"
      ></i>
    </header>
    <div [(ngbCollapse)]="collapseTradeSpecialtyCategories">
      <app-admin-admin-trade-specialty-categories></app-admin-admin-trade-specialty-categories>
    </div>
  </section>
</div>
